import { z } from 'zod'

import { dbEntitySchema } from './system'
import { metricsListAggregateSchema } from './metric'

export const admissionGroupStatsMetricsSchema = z.object({
  attributionId: z.string().nullish(),
  attributionName: z.string().nullish(),
  attributionType: z.string().nullish(),
  totalAdditionalReservationSpent: z.number().nullish(),
  totalAdmissionGuests: z.number().nullish(),
  totalAdmissionSpent: z.number().nullish(),
  totalExpectedAdmissions: z.number().nullish(),
  totalCancelledAdmissions: z.number().nullish(),
  totalCancelledReservations: z.number().nullish(),
  totalCheckedInAdmissions: z.number().nullish(),
  totalCheckedInReservations: z.number().nullish(),
  totalClosedAdmissions: z.number().nullish(),
  totalClosedReservations: z.number().nullish(),
  totalConfirmedAdmissions: z.number().nullish(),
  totalConfirmedLeads: z.number().nullish(),
  totalConfirmedReservations: z.number().nullish(),
  totalDeniedAdmissions: z.number().nullish(),
  totalDeniedLeads: z.number().nullish(),
  totalDeniedReservations: z.number().nullish(),
  //
  totalExpectedReservations: z.number().nullish(),
  totalExpectedTickets: z.number().nullish(),
  totalExpectedGuestlists: z.number().nullish(),
  totalExpectedTallies: z.number().nullish(),
  //expected spent counts
  totalExpectedAdmissionSpent: z.number().nullish(),
  totalExpectedGuestlistSpent: z.number().nullish(),
  totalExpectedReservationSpent: z.number().nullish(),
  totalExpectedTallySpent: z.number().nullish(),
  totalExpectedTicketSpent: z.number().nullish(),
  totalExpectedSpent: z.number().nullish(),
  //expected guest counts
  totalExpectedAdmissionGuests: z.number().nullish(),
  totalExpectedGuestlistGuests: z.number().nullish(),
  totalExpectedReservationGuests: z.number().nullish(),
  totalExpectedTallyGuests: z.number().nullish(),
  totalExpectedTicketGuests: z.number().nullish(),
  //checked in guest counts
  totalCheckedInAdmissionGuests: z.number().nullish(),
  totalCheckedInGuestlistGuests: z.number().nullish(),
  totalConfirmedGuestlistGuests: z.number().nullish(),
  totalClosedGuestlistGuests: z.number().nullish(),
  totalCancelledGuestlistGuests: z.number().nullish(),
  totalCheckedInReservationGuests: z.number().nullish(),
  totalReservationGuests: z.number().nullish(),
  totalCheckedInTallyGuests: z.number().nullish(),
  totalCheckedInTicketGuests: z.number().nullish(),
  //checked in spent counts
  totalCheckedInAdmissionSpent: z.number().nullish(),
  totalCheckedInGuestlistSpent: z.number().nullish(),
  totalCheckedInReservationSpent: z.number().nullish(),
  totalCheckedInTallySpent: z.number().nullish(),
  totalCheckedInTicketSpent: z.number().nullish(),
  //

  totalLeads: z.number().nullish(),
  totalPendingAdmissions: z.number().nullish(),
  totalPendingLeads: z.number().nullish(),
  totalPendingReservations: z.number().nullish(),
  totalPrepaidAdmissionProcessingFees: z.number().nullish(),
  totalPrepaidAdmissionSubtotal: z.number().nullish(),
  totalPrepaidAdmissionTax: z.number().nullish(),
  totalPrepaidAdmissionTip: z.number().nullish(),
  totalPrepaidAdmissionTotal: z.number().nullish(),
  totalPrepaidAdmissionVenueFees: z.number().nullish(),
  totalPrepaidAdmissionVenuePayout: z.number().nullish(),
  totalPrepaidCommission: z.number().nullish(),
  totalPrepaidFeeTotal: z.number().nullish(),
  totalPrepaidGuestlistCommission: z.number().nullish(),
  totalPrepaidGuestlistProcessingFeeTotal: z.number().nullish(),
  totalPrepaidGuestlistProcessingFees: z.number().nullish(),
  totalPrepaidGuestlistSubtotal: z.number().nullish(),
  totalPrepaidGuestlistVenuePayout: z.number().nullish(),
  totalPrepaidProcessingFeeTotal: z.number().nullish(),
  totalPrepaidProcessingFees: z.number().nullish(),
  totalPrepaidReservationProcessingFeeTotal: z.number().nullish(),
  totalPrepaidReservationProcessingFees: z.number().nullish(),
  totalPrepaidReservationSubtotal: z.number().nullish(),
  totalPrepaidReservationTax: z.number().nullish(),
  totalPrepaidReservationTip: z.number().nullish(),
  totalPrepaidReservationTotal: z.number().nullish(),
  totalPrepaidReservationVenueFees: z.number().nullish(),
  totalPrepaidReservationVenuePayout: z.number().nullish(),
  prepaidSubtotal: z.number().nullish(),
  totalPrepaidTallyCommission: z.number().nullish(),
  totalPrepaidTallyProcessingFeeTotal: z.number().nullish(),
  totalPrepaidTallySubtotal: z.number().nullish(),
  totalPrepaidTallyVenuePayout: z.number().nullish(),
  totalPrepaidTax: z.number().nullish(),
  totalPrepaidTicketCommission: z.number().nullish(),
  totalPrepaidTicketProcessingFeeTotal: z.number().nullish(),
  totalPrepaidTicketProcessingFees: z.number().nullish(),
  totalPrepaidTicketSubtotal: z.number().nullish(),
  totalPrepaidTicketTax: z.number().nullish(),
  totalPrepaidTicketTip: z.number().nullish(),
  totalPrepaidTicketTotal: z.number().nullish(),
  totalPrepaidTicketVenueFees: z.number().nullish(),
  totalPrepaidTicketVenuePayout: z.number().nullish(),
  totalPrepaidTip: z.number().nullish(),
  totalPrepaidTotal: z.number().nullish(),
  totalPrepaidUserPaidProcessingFeeTotal: z.number().nullish(),
  totalPrepaidVenueAbsorbedProcessingFeeTotal: z.number().nullish(),
  totalPrepaidVenueFeeTotal: z.number().nullish(),
  totalPrepaidVenueFees: z.number().nullish(),
  totalPrepaidVenuePayout: z.number().nullish(),
  totalReservations: z.number().nullish(),
  totalAdmissions: z.number().nullish(),
  totalTallies: z.number().nullish(),
  //total spent
  totalSpent: z.number().nullish(),
  totalReservationSpent: z.number().nullish(),
  totalGuestlistSpent: z.number().nullish(),
  totalTallySpent: z.number().nullish(),
  totalTicketSpent: z.number().nullish(),
  totalTickets: z.number().nullish(),
  totalVisits: z.number().nullish(),
})

export const admissionGroupLeadTotalsSchema = z.object({
  totalPendingLeads: z.number().nullish(),
  totalConfirmedLeads: z.number().nullish(),
})

export const admissionGroupStatsSchema = dbEntitySchema.extend({
  organization: z.string(),
  venues: z.array(z.string()).nullish(),
  dateStart: z.date(),
  dateEnd: z.date(),
  type: z.string(),
  totals: admissionGroupStatsMetricsSchema.nullish(),
  leadTotals: admissionGroupLeadTotalsSchema.nullish(),
  metrics: metricsListAggregateSchema,
})

export const admissionGroupStatsByVenueResponseSchema = z.object({
  data: admissionGroupStatsSchema.pick({
    organization: true,
    venues: true,
    dateStart: true,
    dateEnd: true,
    totals: true,
    leadTotals: true,
    metrics: true,
  }),
})
